import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';
import Reorder from 'react-reorder';
import { Style } from 'radium';

import { request } from '../../containers/actions';
import Questions from '../questions/component';
import QuestionTag from '../questions/question_tag';
import { clearSelection, toggleSelection } from '../../paginator/actions';
import { reorder, addQuestion, removeQuestion, setFake, setCoefficient } from './actions';
import * as styles from '../../styles';
import { host_v2 } from '../../utilities/requests';


export default class QuestionsSelector extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        classId: '_' + window.uuidv4(),
    }

    listSelector = createSelector(
        [() => this.props.store.getIn(['main', 'selectedQuestions'])],
        selectedQuestions => selectedQuestions.toJS(),
    )

    constructor(props) {
        super(props);
        this.setActions(props);
        this.template = this.template.bind(this);
        this.reorderCallback = this.reorderCallback.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.store.getIn(['questions', 'selected']) !== this.props.store.getIn(['questions', 'selected']))
            this.setActions(nextProps);
    }

    setActions(props) {
        this.actions = [];
        if (props.store.getIn(['questions', 'selected']).size > 0) {
            let questionIds = [];
            let newQuestionsList = [];
            _.map(props.store.getIn(['main' , 'questions']).toJS() , item =>{
                questionIds.push(item.question_id);
            })
            _.map(props.store.getIn(['questions', 'selected']).toJS() , item =>{
                if(!questionIds.includes(item.id)){
                    newQuestionsList.push(item)
                }
            })
            this.actions.push({
                label: props.store.getIn(['questions', 'selected']).size > 1
                    ? window.gettext('Add Questions')
                    : window.gettext('Add Question'),
                action: (() => {
                    this.context.store.dispatch([
                        ..._.map(
                            newQuestionsList,
                            item => addQuestion(
                                item,
                                props.store.getIn(['main', 'elementId']),
                            ),
                        ),
                        clearSelection(props.store.getIn(['questions', 'paginator', 'elementId'])),
                    ]);
                }),
            });
        }
        this.actions.push({
            label: window.gettext('Add Fake Question'),
            action: async () => {
                const payload = {
                    subjects: props.store.getIn(['questions', 'questionDialog', 'subjectsFilter', 'selected']).map((__, id) => ({ id })).toArray(),
                    labels: props.store.getIn(['questions', 'questionDialog', 'labelsTreeFilter', 'selected']).map((__, id) => ({ id })).toArray(),
                    fake: true,
                };
                const response = await this.context.store.dispatch(request({
                    path: '/question/',
                    body: payload,
                    method: 'POST',
                }));
                this.context.store.dispatch(addQuestion(
                    response,
                    props.store.getIn(['main', 'elementId']),
                ));
            },
        });
    }

    template(props) {
        return <div key={props.item} style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', left: '.3em', top: '0', zIndex: '3' }}>
                <i
                    className='fa-close'
                    style={{ float: 'left', cursor: 'pointer', marginRight: '.2em' }}
                    onClick={event => {
                        event.stopPropagation();
                        this.context.store.dispatch(removeQuestion(
                            props.item,
                            this.props.store.getIn(['main', 'elementId']),
                        ));
                    }}>
                </i>
                <i
                    className={this.props.store.getIn(['main', 'questions', props.item, 'fake']) ? 'fa-sign-out' : 'fa-sign-in'}
                    style={{ float: 'left', cursor: 'pointer', marginRight: '.2em' }}
                    onClick={event => {
                        event.stopPropagation();
                        this.context.store.dispatch(setFake(
                            props.item,
                            !this.props.store.getIn(['main', 'questions', props.item, 'fake']),
                            this.props.store.getIn(['main', 'elementId']),
                        ));
                    }}>
                </i>
                <i
                    className='fa-check'
                    style={{ float: 'left', cursor: 'pointer', marginRight: '.2em' }}
                    onClick={event => {
                        event.stopPropagation();
                        this.context.store.dispatch(toggleSelection(
                            { id: this.props.store.getIn(['main', 'questions', props.item, 'question_id']) },
                            this.props.store.getIn(['questions', 'paginator', 'elementId']),
                        ));
                    }}>
                </i>
                <div
                    style={{
                        float: 'left',
                        cursor: 'pointer',
                        marginRight: '.2em',
                        marginTop: '.0625em',
                        lineHeight: '.9em',
                        backgroundColor: 'rgba(240, 240, 240, .6)',
                        paddingTop: '.2em',
                        color: 'red',
                    }}
                    onClick={event => {
                        event.stopPropagation();
                        const coefficient = prompt(window.interpolate(
                            window.gettext('Enter coefficient for question %(index)s:'),
                            { index: (this.props.store.getIn(['main', 'questions', props.item, 'index']) + 1).persian() },
                            true,
                        ).persian(), this.props.store.getIn(['main', 'questions', props.item, 'coefficient']));
                        if (String(Number.parseInt(coefficient)) != coefficient) {
                            alert('Coefficient should be an integer greater than or equal to 1');
                            return;
                        }
                        this.context.store.dispatch(setCoefficient(
                            props.item,
                            Number.parseInt(coefficient),
                            this.props.store.getIn(['main', 'elementId']),
                        ));
                    }}>
                    {this.props.store.getIn(['main', 'questions', props.item, 'coefficient']).persian()}
                </div>
            </div>
            <QuestionTag store={this.props.store.getIn(['main', 'questions', props.item])} />
        </div>;
    }

    GotoUrlExportExcelExamIdAndIndex() {
        var token = this.context.store.getState().get('application').get('token');
        var auth = token.get('accessToken');
        var id = window.location.href.split('/')[4];
        console.log("id",id);
        var url = host_v2 + "/ExportExcel/ExamIdAndIndex?examId=" + id;
        // debugger 
        window.open(url, '_blank');
    }

    reorderCallback(event, object, from, to, items) {
        this.context.store.dispatch(reorder(
            items,
            this.props.store.getIn(['main', 'elementId']),
        ));
    }

    render() {
        let reOrderPart = null;
        try {
            reOrderPart = <Reorder
                itemKey='id'
                lock='horizontal'
                list={this.listSelector(this.props.store)}
                listClass={this.state.classId}
                template={this.template}
                callback={this.reorderCallback}
            />

        } catch (e) { }
        return <span>
            <div style={{ maxWidth: '43em' }}>
                <Questions
                    store={this.props.store.get('questions')}
                    pageSize={16}
                    selectable
                    buttonActions={this.actions}
                    id={this.props.active ? this.props.params.questionId : undefined}
                />
            </div>
            <div
                style={{
                    float: 'right',
                    marginRight: '2em',
                    width: 'calc(100% - 45em)',
                    backgroundColor: 'white',
                }}>
                <div
                    style={{
                        fontSize: '2.5em',
                        color: '#5e5e5e',
                    }}>
                    {window.gettext('Selected Questions')}
                </div>
                <button onClick={() => this.GotoUrlExportExcelExamIdAndIndex()} style={styles.defaultButton}>خروجی اکسل شماره و آیدی سوالات</button>
                <Style
                    scopeSelector=
                    {`.${this.state.classId} .placeholder div`}
                    rules={{
                        backgroundColor: '#cccccc',
                        color: '#cccccc',
                    }}>
                </Style> 
                {reOrderPart}
            </div>
        </span>;
    }
}
